Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutlined = void 0;
var _styles = require("../../../../../styles");
var _reactNative = require("react-native-web");
var useOutlined = exports.useOutlined = function useOutlined() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    boxShadows = _STYLES$useStyles.boxShadows;
  var outlined = {
    label: Object.assign({
      textDecorationLine: 'none',
      backgroundColor: colors.background,
      color: colors.brand
    }, _reactNative.Platform.select({
      web: {
        border: "".concat((0, _styles.getREM)(0.125), " solid ").concat(colors.brand),
        cursor: 'pointer'
      },
      "default": {
        borderColor: colors.brand,
        borderWidth: (0, _styles.getREM)(0.125),
        borderStyle: 'solid'
      }
    }), boxShadows.button.web, boxShadows.button.android),
    pointerOver: Object.assign({}, boxShadows.button_pointerOver.web)
  };
  return {
    outlined: outlined
  };
};